__turbopack_context__.v({
  "aside": "ContainerTwoColumns-module-sass-module__HQkg4q__aside",
  "container": "ContainerTwoColumns-module-sass-module__HQkg4q__container",
  "main": "ContainerTwoColumns-module-sass-module__HQkg4q__main",
});
